import { DefenderDeclarationGame } from '../models/defender-declaration-game'
import { DefenderDeclarationGameDto } from '../dtos/defender-declaration-game.dto'
import { gamePropsMapper } from './game-props.mapper'
import { DefendOption } from '../models/defend-option'

export const defenderDeclarationGameMapper = {
  mapToDefenderDeclarationGame(
    defenderDeclarationGameDto: DefenderDeclarationGameDto,
  ): DefenderDeclarationGame {
    return new DefenderDeclarationGame({
      ...defenderDeclarationGameDto,
      ...gamePropsMapper.mapToGameProps(defenderDeclarationGameDto),
      userDefendOptions: defenderDeclarationGameDto.userDefendOptions.map(
        (defendOptionType) => new DefendOption(defendOptionType),
      ),
    })
  },
}
